<template>
  <v-dialog v-model="modalOpen">
    <v-card>
      <v-card-title> Nueva recomendación </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-text-field v-model="form.name" label="Nombre" />
          </v-col>
          <v-col cols="4">
            <v-file-input
              v-model="form.file"
              label="Archivo"
              accept="application/pdf"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn dark class="red" @click="closeModal">
          <v-icon left>mdi-close</v-icon>
          Cerrar
        </v-btn>
        <v-btn color="green" dark @click="save">
          <v-icon left> mdi-content-save </v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["modal"],
  watch: {
    modal(value) {
      this.modalOpen = value;
    },
  },
  data() {
    return {
      modalOpen: false,
      form: {},
    };
  },
  methods: {
    save() {
      this.openLoader();
      window.setTimeout(() => {
        const form = new FormData();
        Object.keys(this.form).map((k) => {
          form.append(k, this.form[k]);
        });
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/recommendations",
          form,
          "POST",
          true
        );
        request
          .then(({ message }) => {
            this.showSuccessMessage(message);
            this.closeModal();
          })
          .finally(() => this.closeLoader());
      }, 500);
    },
    closeModal() {
      this.modalOpen = false;
      this.$emit("close-modal");
    },
  },
};
</script>